/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import _Divider from './divider.mjs';
import withInstall from '../utils/withInstall.mjs';
import './style/css.mjs';
import './type.mjs';
import '../_chunks/dep-6e49aa22.mjs';
import '../_chunks/dep-6da93342.mjs';
import 'vue';
import './props.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/hooks/useConfig.mjs';
import 'lodash-es';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-5112e56c.mjs';
import '../utils/render-tnode.mjs';

var Divider = withInstall(_Divider);

export { Divider, Divider as default };
//# sourceMappingURL=index.mjs.map
